/**
 * @generated SignedSource<<cdcd0699770068cba5d2c9a58262e5e8>>
 * @relayHash ac94eaa66417782eeaa23f43a9b4c831
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d723f1c2c2c102b89a4e96a2bad4b2989a40182d73df128b31fd5bfbabb800f3

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { VirtualAgentBrowseIntents788BadPatternQuery } from './VirtualAgentBrowseIntents788BadPatternQuery.graphql';

import newPerformancePage_provider from '@jira/platform__graphql-relay-provider/src/jsm-va-enable-performance-page.relayprovider';

const node: PreloadableConcreteRequest<VirtualAgentBrowseIntents788BadPatternQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d723f1c2c2c102b89a4e96a2bad4b2989a40182d73df128b31fd5bfbabb800f3",
    "metadata": {},
    "name": "VirtualAgentBrowseIntents788BadPatternQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmvaenableperformancepagerelayprovider": newPerformancePage_provider
    }
  }
};

export default node;
